<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="subcategories"
    :search="search"
    @dblclick:row="handleClickRow"
    sort-by="id"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>SUBCATEGORIAS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" dark to="/subcategoria/novo">
          <v-icon>mdi-plus</v-icon>
          Novo
        </v-btn>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-toolbar color="red lighten-1" dark class="text-h5"
              >Atenção</v-toolbar
            >
            <v-card-title class="text-h6">
              Tem certeza que deseja Deletar?
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Fechar</v-btn
              >
              <v-btn color="red darken-1" dark @click="deleteItemConfirm">
                <v-icon dark>mdi-delete</v-icon>
                Deletar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.updated_at="{ item }">
      {{ item.updated_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>
        {{ getLabel(item.status) }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-tooltip top color="blue darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="blue darken-1"
            @click="editItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-pencil
          </v-icon>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip top color="error">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="red darken-1"
            @click="deleteItem(item)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-delete
          </v-icon>
        </template>
        <span>Deletar</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import * as API from "@/api/requests/SubcategoryRequest";

export default {
  data: () => ({
    dialogDelete: false,
    search: "",
    loading: false,
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
        width: 50,
      },
      { text: "Nome", value: "name", width: 350 },
      { text: "Categoria", value: "category.name", width: 350 },
      { text: "Status", value: "status", width: 100 },
      { text: "Data Cadastro", value: "created_at", width: 200 },
      { text: "Última Atualização", value: "updated_at", width: 200 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    subcategories: [],
    editedItem: {
      name: "",
      status: 1,
    },
    defaultItem: {
      name: "",
      status: 1,
    },
  }),

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getSubcategories();
    },
    getColor(status) {
      return status == 1 ? "green" : "red";
    },
    getLabel(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },

    async getSubcategories() {
      this.loading = true;
      this.subcategories = [];
      try {
        this.subcategories = await API.getAll();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.$router.push({ name: "SubcategoryEdit", params: { id: item.id } });
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.loading = true;
      this.subcategories = [];
      try {
        await API.destroy(this.editedItem.id);
        this.loading = false;
        this.initialize();
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    handleClickRow(event, item) {
      this.editItem(item.item);
    },
  },
};
</script>
